/* tslint:disable */

// AUTO-GENERATED FILE. DO NOT EDIT.

export const CURRENT_REVISION = "6f201589fed406bce5aa9f74984063261a430bbb";
